<template>
  <div class="pt-6">
    <Banner v-if="widthNow >= 550" />
    <BannerMobile v-else />
    <MapCard  v-if="widthNow >= 550" />
    <div v-else style="margin-top: 2.5rem;">
      <MapCardMobile />
    </div>
  </div>
</template>
<script>
import Banner from "../components/HubungiKami/Banner.vue";
import BannerMobile from "../components/HubungiKami/BannerMobile.vue";
import MapCard from "../components/HubungiKami/MapCard.vue";
import MapCardMobile from "../components/HubungiKami/MapCardMobile.vue";
export default {
  components: { Banner, BannerMobile, MapCard, MapCardMobile },
  data: () => ({
    heightNow: window.innerHeight,
    widthNow: window.innerWidth,
  }),
  methods: {
    created() {
      window.addEventListener("resize", this.myEventHandler);
    },
    myEventHandler() {
      // console.log(e);
      this.heightNow = window.innerHeight;
      this.widthNow = window.innerWidth;

      // your code for handling resize...
    },
  },
};
</script>
<style scoped></style>
